import { render, staticRenderFns } from "./Calculator.vue?vue&type=template&id=74bafc35&scoped=true&"
import script from "./Calculator.vue?vue&type=script&lang=js&"
export * from "./Calculator.vue?vue&type=script&lang=js&"
import style0 from "./Calculator.vue?vue&type=style&index=0&id=74bafc35&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74bafc35",
  null
  
)

export default component.exports
import {QLayout,QHeader,QToolbar,QToolbarTitle,QPageContainer,QPage,QForm,QItemLabel,QSelect,QInput,QBtn,QCard,QExpansionItem,QSeparator} from 'quasar'
component.options.components = Object.assign({QLayout,QHeader,QToolbar,QToolbarTitle,QPageContainer,QPage,QForm,QItemLabel,QSelect,QInput,QBtn,QCard,QExpansionItem,QSeparator}, component.options.components || {})
